import { AwardJudge, AwardJudgeRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const assignAwardJudge: (
  fetchContext: FetchContext,
  awardId: number,
  judge: AwardJudge,
  accessToken?: string,
) => Promise<AwardJudgeRef> = (fetchContext, awardId, judge, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/awards/${awardId}/judges`,
  {
    method: 'POST',
    body: JSON.stringify(judge),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<AwardJudgeRef>(fetchContext.errorStore, response, 'assign award judge'));
